import React, { useState, useEffect } from 'react';
import { Modal, Button, Input } from '../common';

export const EditGameModal = ({
  isOpen,
  onClose,
  game,
  onSave,
  isSaving = false,
}) => {
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    outcome: '',
    setting: '',
    tone: '',
    discordWebhookUrl: '',
  });

  // Populate form when game data changes
  useEffect(() => {
    if (game) {
      setFormData({
        title: game.title || '',
        description: game.description || '',
        outcome: game.outcome || '',
        setting: game.premise?.setting || '',
        tone: game.premise?.tone || '',
        discordWebhookUrl: game.settings?.notifications?.discordWebhookUrl || '',
      });
    }
  }, [game]);

  const handleChange = (field) => (e) => {
    setFormData((prev) => ({
      ...prev,
      [field]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const updateData = {
      title: formData.title,
      description: formData.description,
      outcome: formData.outcome,
      premise: {
        setting: formData.setting,
        tone: formData.tone,
      },
      settings: {
        notifications: {
          discordWebhookUrl: formData.discordWebhookUrl || null,
        },
      },
    };

    await onSave(updateData);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Edit Game Details" size="md">
      <form onSubmit={handleSubmit} className="space-y-4">
        <Input
          label="Title"
          value={formData.title}
          onChange={handleChange('title')}
          placeholder="Game title"
          required
        />

        <div className="w-full">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Description
          </label>
          <textarea
            value={formData.description}
            onChange={handleChange('description')}
            placeholder="A brief description of the game"
            rows={3}
            className="
              w-full px-3 py-2
              border border-gray-300 rounded-lg
              text-gray-900 placeholder-gray-400
              focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent
              resize-none
            "
          />
        </div>

        <Input
          label="Outcome"
          value={formData.outcome}
          onChange={handleChange('outcome')}
          placeholder="What are the players trying to achieve?"
        />

        <Input
          label="Setting"
          value={formData.setting}
          onChange={handleChange('setting')}
          placeholder="Where does the story take place?"
        />

        <Input
          label="Tone"
          value={formData.tone}
          onChange={handleChange('tone')}
          placeholder="e.g., Dark, Comedic, Heroic"
        />

        <div className="border-t border-gray-200 pt-4 mt-4">
          <h3 className="text-sm font-medium text-gray-700 mb-2">Notifications</h3>
          <Input
            label="Discord Webhook URL"
            value={formData.discordWebhookUrl}
            onChange={handleChange('discordWebhookUrl')}
            placeholder="https://discord.com/api/webhooks/..."
            type="url"
          />
          <p className="text-xs text-gray-500 mt-1">
            Create a webhook in your Discord server settings under Integrations &gt; Webhooks.
            Notifications will be sent for round starts, phase changes, and player activity.
          </p>
        </div>

        <div className="flex justify-end gap-3 pt-4">
          <Button
            type="button"
            variant="secondary"
            onClick={onClose}
            disabled={isSaving}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            loading={isSaving}
            disabled={!formData.title.trim()}
          >
            Save Changes
          </Button>
        </div>
      </form>
    </Modal>
  );
};
